/**
 * CRUD toast helpers — Faristalo-style copy, using AppNotificationToast `show`.
 * @param {(message: string, options?: object) => void} show — from useAppNotificationToast()
 */
import i18n from '../../i18n';

const t = (key, opts) => i18n.t(key, opts);

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function buildCrudNotifyMessageHtml(entityLabel, detailText) {
  const erp = escapeHtml(t('common.crud_notify.in_erp_brand', { defaultValue: 'Qawaem ERP' }));
  const entity = escapeHtml(entityLabel);
  const detail = escapeHtml(detailText);
  return `<span class="font-semibold">${entity}</span> — ${detail} · <span class="text-red-600 font-semibold">${erp}</span>`;
}

export function notifyCreated(show, entityLabel) {
  show('', {
    variant: 'created',
    topLabel: t('common.crud_notify.created_title', { defaultValue: 'تم الإنشاء' }),
    messageHtml: buildCrudNotifyMessageHtml(
      entityLabel,
      t('common.crud_notify.created_detail', { defaultValue: 'تم الحفظ ويظهر في أعلى القائمة' }),
    ),
  });
}

export function notifyUpdated(show, entityLabel) {
  show('', {
    variant: 'success',
    topLabel: t('common.crud_notify.updated_title', { defaultValue: 'تم التحديث' }),
    messageHtml: buildCrudNotifyMessageHtml(
      entityLabel,
      t('common.crud_notify.updated_detail', { defaultValue: 'تم التحديث ويظهر في أعلى القائمة' }),
    ),
  });
}

export function notifyDeleted(show, entityLabel) {
  show('', {
    variant: 'deleted',
    status: 'deleted',
    topLabel: t('common.crud_notify.deleted_title', { defaultValue: 'تم الحذف' }),
    messageHtml: buildCrudNotifyMessageHtml(
      entityLabel,
      t('common.crud_notify.deleted_detail', { defaultValue: 'تم الحذف من القائمة' }),
    ),
  });
}

export function notifyBulkDeleted(show, count, entityLabel) {
  show('', {
    variant: 'deleted',
    status: 'deleted',
    topLabel: t('common.crud_notify.deleted_title', { defaultValue: 'تم الحذف' }),
    messageHtml: buildCrudNotifyMessageHtml(
      entityLabel,
      t('common.crud_notify.bulk_deleted_detail', {
        count,
        defaultValue: `تم حذف ${count} عنصر(ات)`,
      }),
    ),
  });
}

export function notifyError(show, message) {
  show(message || t('common.crud_notify.error_body', { defaultValue: 'حدث خطأ — يرجى المحاولة مرة أخرى' }), {
    variant: 'error',
    status: 'error',
    topLabel: t('common.crud_notify.error_title', { defaultValue: 'تعذّر الإجراء' }),
  });
}
